import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { X } from 'lucide-react';

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    // Check if user previously dismissed the banner
    const bannerDismissed = localStorage.getItem('welcomeBannerDismissed_v2');
    if (bannerDismissed) {
      setShowBanner(false);
    }
  }, []);

  const dismissBanner = () => {
    setShowBanner(false);
    localStorage.setItem('welcomeBannerDismissed_v2', 'true');
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setIsSidebarOpen(false);
      else setIsSidebarOpen(true);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 text-gray-900 font-sans">
      <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      
      <div className="flex-1 flex flex-col h-full overflow-x-hidden overflow-y-auto relative min-w-0">
        <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-3 sm:p-4 md:p-8 custom-scrollbar min-w-0">
          {showBanner && (
            <div className="max-w-7xl mx-auto w-full mb-4 sm:mb-6 relative">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl shadow-md p-4 sm:p-5 pr-10 text-white flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 overflow-hidden relative">
                {/* Decorative background shapes */}
                <div className="absolute top-0 right-0 -mr-16 -mt-16 w-48 h-48 rounded-full bg-white opacity-10 blur-3xl pointer-events-none"></div>
                <div className="absolute bottom-0 right-1/4 w-24 h-24 rounded-full bg-white opacity-10 blur-2xl pointer-events-none"></div>
                
                <div className="relative z-10 flex-1">
                  <h2 className="text-lg sm:text-xl font-bold mb-1 flex items-center gap-2">
                    Welcome to your new Chalksnboard Dashboard! 🎉
                  </h2>
                  <p className="text-blue-100 max-w-2xl text-xs sm:text-sm leading-relaxed">
                    Enjoy the fresh new design and a seamless mobile experience! Managing your attendance and leaves is now easier than ever.
                  </p>
                </div>
                
                <button 
                  onClick={dismissBanner}
                  className="absolute top-2 right-2 z-10 p-1.5 text-white/60 hover:text-white hover:bg-white/20 rounded-full transition-all duration-200"
                  title="Dismiss Welcome Message"
                >
                  <X size={18} />
                </button>
              </div>
            </div>
          )}

          <div className="max-w-7xl mx-auto w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
